"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDIT_PRODUCT_TREE_NODE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.EDIT_PRODUCT_TREE_NODE = (0, gql_1.gql)(`
   mutation UpdateProductTreeNode($productTreeNode: UpdateProductTreeNodeInput!) {
    updateProductTreeNode(productTreeNode: $productTreeNode) {
      error
      success
    }
  }
`);
